export default __webpack_public_path__ + "static/media/kleinbus_cockpit.84c7a1e3.jpg";